import React, { useEffect, useRef, useState } from "react";
import {
  Corousel1Wrapper,
  Corousel1ImageContainer,
  Corousel1FadingDiv,
  Corousel1Image,
  Corousel1ImageDescription,
  Corousel2Wrapper,
  Corousel2ImageContainer,
  Corousel2Controls,
  Corousel2Control,
  LeftArrowWrapper,
  RightArrowWrapper,
  PlayPauseWrapper,
  Icon,
  SlideTextWrapper,
  P,
  H1,
} from "./elements";

const DEFAULT_IMAGES_1 = [
  { src: "images/corousel1/image1.jpg" },
  { src: "images/corousel1/image2.jpg" },
  { src: "images/corousel1/image3.jpg" },
  { src: "images/corousel1/image4.jpg" },
  { src: "images/corousel1/image5.jpg" },
  { src: "images/corousel1/image6.jpg" },
  { src: "images/corousel1/image7.jpg" },
  { src: "images/corousel1/image8.jpg" },
  { src: "images/corousel1/image9.jpg" },
  { src: "images/corousel1/image10.jpg" },
  { src: "images/corousel1/image11.jpg" },
];
const DEFAULT_IMAGES_2 = [
  { src: "images/corousel2/image1.jpg" },
  { src: "images/corousel2/image2.jpg" },
  { src: "images/corousel2/image3.jpg" },
  { src: "images/corousel2/image4.jpg" },
  { src: "images/corousel2/image5.jpg" },
  { src: "images/corousel2/image6.jpg" },
];

export const Corousel1 = ({ images = DEFAULT_IMAGES_1, visibleImages = 5 }) => {
  const descrAnimation = useRef([]);
  const [hoveringIndex, setHoveringIndex] = useState(-1);
  const [baseLeftOffset, setBaseLeftOffset] = useState(50);
  const [imagesStyle, setImagesStyle] = useState([]);

  const [visibleImagesIndices, setVisibleImagesIndices] = useState(
    [...Array(visibleImages)].map((_, i) => i)
  );
  const fadingOpacity = useRef(1);

  useEffect(() => {
    descrAnimation.current = [...Array(images.length)].map(() => false);
  }, [images.length]);
  useEffect(() => {
    let isMounted = true;
    const updateIndices = () => {
      let newIndices = [...visibleImagesIndices];
      newIndices.shift();
      let indexToBeAdded =
        newIndices[visibleImages - 2] === images.length - 1
          ? 0
          : newIndices[visibleImages - 2] + 1;
      newIndices.push(indexToBeAdded);
      setVisibleImagesIndices(newIndices);
      setBaseLeftOffset(50);
      fadingOpacity.current = 1;
    };
    const updateStyles = () => {
      const newStyles = [...Array(images.length)].map((_, index) => {
        if (visibleImagesIndices.indexOf(index) === -1)
          //hide images which are not in view
          return { display: "none" };
        else {
          let pos = 350 * visibleImagesIndices.indexOf(index) + baseLeftOffset;
          return { left: pos + "px" };
        }
      });
      setImagesStyle(newStyles);
    };
    if (baseLeftOffset <= -300) return updateIndices();
    updateStyles();
    if (hoveringIndex === -1)
      setTimeout(() => {
        if (isMounted) setBaseLeftOffset(baseLeftOffset - 1);
      }, 10);
    return () => (isMounted = false);
  }, [
    visibleImagesIndices,
    images.length,
    visibleImages,
    baseLeftOffset,
    hoveringIndex,
  ]);

  const slides = images.map((_, i) => {
    let animationName = "";
    if (hoveringIndex === i) {
      animationName = "moveUp";
      descrAnimation.current[i] = true;
    } else if (descrAnimation.current[i]) animationName = "moveDown";

    return (
      <Corousel1ImageContainer
        key={i}
        style={imagesStyle[i]}
        onMouseEnter={() => setHoveringIndex(i)}
        onMouseLeave={() => setHoveringIndex(-1)}
      >
        <Corousel1Image
          src={images[i].src}
          alt={"Image " + i + " Not loaded"}
        />
        <Corousel1ImageDescription animationName={animationName}>
          This is image description for image {i}
        </Corousel1ImageDescription>
      </Corousel1ImageContainer>
    );
  });

  return (
    <Corousel1Wrapper>
      <Corousel1FadingDiv appear={true} />
      <Corousel1FadingDiv appear={false} />
      {slides}
    </Corousel1Wrapper>
  );
};

export const Corousel2 = ({ images = DEFAULT_IMAGES_2 }) => {
  const [selectedSlide, setSelectedSlide] = useState(0);
  const [autoPlay, setAutoPlay] = useState(true);

  useEffect(() => {
    if (autoPlay) {
      const interval = setInterval(() => {
        setSelectedSlide((o) => (o + 1) % images.length);
      }, 3000);
      return () => clearInterval(interval);
    }
  }, [images.length, autoPlay]);

  const incrementSlideCount = () => setSelectedSlide((o) => o + 1);
  const decrementSlideCount = () => setSelectedSlide((o) => o - 1);
  const togglePlay = () => setAutoPlay((o) => !o);

  const controls = [...Array(images.length)].map((_, id) => (
    <Corousel2Control
      key={id}
      selected={selectedSlide === id}
      onClick={() => setSelectedSlide(id)}
    />
  ));
  const imageContainers = images.map((image, id) => (
    <Corousel2ImageContainer
      key={id}
      selectedSlide={selectedSlide}
      selected={id <= selectedSlide}
    >
      <img src={image.src} alt={"image " + id} />
      <SlideTextWrapper>
        <H1>Punch line for Image</H1>
        <P>
          Description lines for Image Irure magna reprehenderit mollit
          duis adipisicing consectetur est cillum exercitation Lorem et mollit
        </P>
      </SlideTextWrapper>
    </Corousel2ImageContainer>
  ));
  return (
    <Corousel2Wrapper>
      {imageContainers}
      <Corousel2Controls>{controls}</Corousel2Controls>
      <LeftArrowWrapper
        visible={selectedSlide !== 0}
        onClick={decrementSlideCount}
      >
        <i className="fas fa-chevron-left" />
      </LeftArrowWrapper>
      <RightArrowWrapper
        visible={selectedSlide !== images.length - 1}
        onClick={incrementSlideCount}
      >
        <i className="fas fa-chevron-right" />
      </RightArrowWrapper>
      <PlayPauseWrapper>
        <Icon
          className="fas fa-play"
          onClick={togglePlay}
          visible={autoPlay ? 0 : 1}
        />
        <Icon
          className="fas fa-pause"
          onClick={togglePlay}
          visible={autoPlay ? 1 : 0}
        />
      </PlayPauseWrapper>
    </Corousel2Wrapper>
  );
};
